import { Component, Input } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { MCustomerMenuProductListResponse, MCustomerMenuSubcategoryResponse } from 'src/app/pages/homepage/homepage.module';
import { SharedPrefrences } from 'src/app/utils/utils.service';
import { WsSubHeaderService } from 'src/app/ws/wsSubHeader/ws-sub-header.service';
import { Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';

import { MCustomerMenuCategoryResponse } from 'src/app/pages/homepage/homepage.module';

@Component({
  selector: 'app-sub-header-hover-category',
  templateUrl: './sub-header-hover-category.component.html',
  styleUrls: ['./sub-header-hover-category.component.scss']
})
export class SubHeaderHoverCategoryComponent {
  showNavBar = false
  @Input() customerMenuLists: any
  selectedCategoryName = ""
  selectedSubcategories?: any
  selectedProducts?: any
  selectedSubCategory: any;
  constructor(private wssubheaderservice: WsSubHeaderService,
    private broadCastService: BroadCastService,
    private router: Router) { }

  ngOnInit() {
  }

  hideShowMenu(customerMenuList: any) {
    this.selectedProducts = customerMenuList.subCategoriesList[0].productList;
    this.selectedSubCategory = customerMenuList.subCategoriesList[0].id;

  }
  subCategoryClick(productList: MCustomerMenuProductListResponse, selectedSubcategory: any) {
    this.selectedSubCategory = selectedSubcategory;
    this.selectedProducts = productList;
  }

  productClick(product: MCustomerMenuProductListResponse) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    var productName = product.name.split(' ').join('_').replace(',', '')
    this.router.navigate(["/product-detail-updated/" + product.id + '/' + productName.replace(/[&\/\#,+()$~%.'":*?<>{}]/g,'_')])
  }

  /**
  * Date:- 09-06-2023
  * Method :- This method is used to get Customer menu List  With Details
  */
  async getCustomerMenuList() {
    const customerMenuListData = this.wssubheaderservice.getCustomerMenuList();
    await lastValueFrom(customerMenuListData).then(response => {
      if (response && response.statusCode == 200) {
        this.customerMenuLists = response.data.categoryList;
        SharedPrefrences.setCategoryId(this.customerMenuLists[0].id)
        SharedPrefrences.setCustomerMenuList(JSON.stringify(response.data))
        this.broadCastService.sendMessage(response.data)
      }
    })
  }


  goToShopAll(val: any, catId: any, subId?: any) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(["/shop-all/" + val], { 
      queryParams: { 
        c: catId
      }
  })
  }
}
/**
 * Modal for Customer Menu list Response
 */
export class MCustomerMenuResponse {
  statusCode!: number;
  message!: string;
  data!: MCustomerMenuListResponseData
  token!: string;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

/**
 * Modal of Customer Menu Response Data
 */
export class MCustomerMenuListResponseData {
  categoryList?: [MCustomerMenuCategoryResponse];
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}


@Injectable()

export class BroadCastService {

  subject = new Subject<any>();

  constructor(private router: Router) { }

  sendMessage(data: any) {
    this.subject.next(data);
  }

  clearMessage() {
    this.subject.next(0);
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}   